import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation("home");

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=dramatic%20Chinese%20internet%20celebrity%20culture%20scene%20with%20dynamic%20motion%20blur%20on%20right%20side%2C%20warm%20crimson%20red%20and%20deep%20gold%20tones%2C%20mysterious%20dark%20atmosphere%20with%20neon%20accents%2C%20entertainment%20industry%20vibe%2C%20cinematic%20lighting%20with%20high%20contrast%2C%20editorial%20fashion%20photography%20style%2C%20abstract%20dramatic%20composition%2C%20luxury%20event%20background%20with%20bokeh%20lights&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="51爆料 - 网红每日大赛实时追踪"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-background-50 tracking-tight text-center">
          {t("hero.title1")}
        </h1>
        <p className="mt-3 md:mt-4 text-xl md:text-2xl lg:text-3xl text-background-50/90 font-heading italic text-center">
          {t("hero.title2")}
        </p>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/70 max-w-2xl text-center leading-relaxed">
          {t("hero.subtitle")}
        </p>
        <Link
          to="/category/wanghong-dasai"
          className="mt-6 md:mt-8 px-8 py-3 bg-background-50 text-primary-600 font-label font-medium rounded-full whitespace-nowrap hover:bg-primary-50 transition-all duration-200 cursor-pointer text-sm md:text-base"
        >
          {t("hero.cta")}
          <i className="ri-arrow-right-line ml-2"></i>
        </Link>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex items-start justify-center">
          <div className="w-1 h-2 bg-background-50/60 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}